import axios from "axios";
import { useCallback, useMemo, useState } from "react";
import { useRedirect } from "react-admin";
import { FieldValues } from "react-hook-form";
import { getRawUrlBase, PlanningResourcesEnum } from "shared/enums/resourceMappings";
import { PlanningType } from "shared/types";
import { mapValuesToApi } from "../mapToApi";
import { GenericPlanningConfig } from "../types";

const useFingridTestGenericPlanningsForm = (initialData: FieldValues, configs: GenericPlanningConfig[]) => {
  const redirect = useRedirect();
  const [isLoading, setIsLoading] = useState(false);

  const orderedConfigs = useMemo(() => configs, [configs]);

  const handleSubmit = useCallback(
    async (values: FieldValues) => {
      setIsLoading(true);

      const sitePlannings: PlanningType[] = mapValuesToApi(values);
      const preparedData = initialData.siteIds.reduce((acc: Record<number, PlanningType[]>, siteId: number) => {
        acc[siteId] = sitePlannings;
        return acc;
      }, {});

      try {
        const { status } = await axios({
          method: "post",
          url: `${getRawUrlBase(PlanningResourcesEnum.Plannings)}`,
          data: preparedData,
        });
        if (status >= 200 && status < 300) {
          setIsLoading(false);
          redirect(`/${PlanningResourcesEnum.Plannings}`);
        }
      } catch (error) {
        console.error("error:", error);
        setIsLoading(false);
      }
    },
    [initialData, redirect],
  );
  return {
    handleSubmit,
    isLoading,
    orderedConfigs,
  };
};

export default useFingridTestGenericPlanningsForm;
